/* esm.sh - lit-html@2.8.0/directives/unsafe-html */
import{nothing as i,noChange as r}from"/lit-html@2.8.0/es2022/lit-html.mjs";import{Directive as n,PartType as o,directive as a}from"../directive.mjs";var e=class extends n{constructor(t){if(super(t),this.et=i,t.type!==o.CHILD)throw Error(this.constructor.directiveName+"() can only be used in child bindings")}render(t){if(t===i||t==null)return this.ft=void 0,this.et=t;if(t===r)return t;if(typeof t!="string")throw Error(this.constructor.directiveName+"() called with a non-string value");if(t===this.et)return this.ft;this.et=t;let s=[t];return s.raw=s,this.ft={_$litType$:this.constructor.resultType,strings:s,values:[]}}};e.directiveName="unsafeHTML",e.resultType=1;var f=a(e);export{e as UnsafeHTMLDirective,f as unsafeHTML};
/*! Bundled license information:

lit-html/directives/unsafe-html.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
//# sourceMappingURL=unsafe-html.mjs.map